module.exports = __webpack_public_path__ + "img/add-photo.143a389e.svg";